import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TurneroContainer from '../../containers/TurneroContainer';
import './styles.css'

const drawerWidth = 360;

const styles = (theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    opacity: 1
  },
  drawerPaper: {
    width: drawerWidth,
    background: '#EFF0F8 0% 0% no-repeat padding-box',
    opacity: 1,
    zIndex: 1501,
    border: 'none'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
});

class Calendario extends React.Component {
 
  toFixedCustomize = (num) => {
    var resultado = num.toFixed(6).slice(0, -4)
    return resultado
  }
  
  render() {
    
    const { classes } = this.props

    return (
      <Drawer
        className={`${classes.drawer}`}
        anchor="right"
        open={true}
        classes={{ paper: classes.drawerPaper }}
        onClose={this.props.handleOnClose}
      >
        <div className='containerCalendario'>

          <IconButton
            color="default"
            aria-label="Back"
            className='arrowCloseResumen'
            onClick={this.props.handleOnClose}
          >
            <ArrowBackIcon />
          </IconButton>

          <div className='tituloCalendario'>Turnos disponibles</div>
          
          <div className='notaCalendario'>
            Considera que mientras vos estás efectuando tu compra, 
            otros clientes pueden estar cerrando pedidos, 
            consumiendo cupos que en estos momentos figuran como disponibles.
          </div>
          
          <div id='scrollItemsCalendario' className={`CalendarioItems`}>
            
            <ExpansionPanel>
              <ExpansionPanelSummary
                className='panelNotificacion'
                expandIcon={<ExpandMoreIcon style={{ color: '#FFFFFF' }} />}
              >
                <div>
                  <Typography style={{ marginBottom: '1rem', color: 'white', fontSize: '13px' }}>Calendario</Typography>
                  <Typography className={`${classes.heading} labelNota`}>PICKUP</Typography>
                </div>
              </ExpansionPanelSummary>

              <ExpansionPanelDetails style={{ padding: '0px' }}>
                <div>
                  <TurneroContainer
                    showDiv={false}
                    listaFechaHora={this.props.calendarioPickup.calendario}
                    diasAdelante={this.props.calendarioPickup.diasAdelante}
                    tipo='PICKUP'
                    showModalTopeDias={false} 
                    handleOnClickDia={()=>{}}
                    handleOnClickHorario={()=>{}}
                    indiceDiaSelected={this.props.calendarioPickup.calendario && this.props.calendarioPickup.calendario.length > 0 ? 0 : undefined}
                    idHorarioSelected={this.props.idHorarioSelected}
                    idDiaSelected={this.props.calendarioPickup.calendario && this.props.calendarioPickup.calendario.length > 0 ? this.props.calendarioPickup.calendario[0].idDiaCalendario : undefined}
                  />
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
              <ExpansionPanelSummary
                className='panelNotificacion'
                expandIcon={<ExpandMoreIcon style={{ color: '#FFFFFF' }} />}
              >
                <div>
                  <Typography style={{ marginBottom: '1rem', color: 'white', fontSize: '13px' }}>Calendario</Typography>
                  <Typography className={`${classes.heading} labelNota`}>DELIVERY</Typography>
                </div>
              </ExpansionPanelSummary>
              
              <ExpansionPanelDetails style={{ padding: '0px' }}>
                <div>
                  <TurneroContainer
                    showDiv={false}
                    listaFechaHora={this.props.calendarioDelivery.calendario}
                    diasAdelante={this.props.calendarioDelivery.diasAdelante}
                    tipo='DELIVERY'
                    showModalTopeDias={false} 
                    handleOnClickDia={()=>{}}
                    handleOnClickHorario={()=>{}}
                    indiceDiaSelected={this.props.calendarioDelivery.calendario && this.props.calendarioDelivery.calendario.length > 0 ? 0 : undefined}
                    idHorarioSelected={this.props.idHorarioSelected}
                    idDiaSelected={this.props.calendarioDelivery.calendario && this.props.calendarioDelivery.calendario.length > 0 ? this.props.calendarioDelivery.calendario[0].idDiaCalendario : undefined}
                  />
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        </div>
      </Drawer>
    );
  }
}
Calendario.defaultProps = {
  open: false,
 

}
Calendario.propTypes = {
  calendarioPickup: PropTypes.array.isRequired,
  calendarioDelivery: PropTypes.array.isRequired,
  handleOnClose:PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  handleOnClickDia: PropTypes.func.isRequired,
  diasAdelante: PropTypes.number.isRequired,
  idDiaSelected: PropTypes.number.isRequired,
  indiceDiaSelected: PropTypes.number.isRequired,
  idTipoCalendario:PropTypes.number.isRequired,
};

export default withStyles(styles, { withTheme: true })(Calendario);